import { DEFAULTS } from '../../constants';

export const toTrimmedString = (value) => (typeof value === 'string' ? value.trim() : '');

export const resolveX3ProductName = (category) => {
  const rawValue =
    category?.x3_productname ??
    category?.x3ProductName ??
    category?.x3_product_name ??
    category?.x3Productname ??
    category?.name ??
    '';
  const normalizedValue = String(rawValue).trim().toUpperCase();
  return normalizedValue || null;
};

export const transformProductCategories = (productCategoriesData) => {
  if (!Array.isArray(productCategoriesData) || productCategoriesData.length === 0) return [];

  const uniqueProductTypes = new Map();
  productCategoriesData.forEach((category) => {
    const id = String(category?.id ?? '').trim();
    const x3ProductName = resolveX3ProductName(category);
    if (!id || !x3ProductName || uniqueProductTypes.has(x3ProductName)) return;
    uniqueProductTypes.set(x3ProductName, {
      id,
      name: x3ProductName,
      x3ProductName,
    });
  });

  return Array.from(uniqueProductTypes.values()).sort((a, b) =>
    (a?.name ?? '').localeCompare(b?.name ?? '', 'en', { sensitivity: 'base' }),
  );
};

export const getSelectedIds = (filterValue) => {
  if (Array.isArray(filterValue)) {
    return filterValue
      .map((item) => {
        if (item === null || item === undefined) return '';
        if (typeof item === 'object') return String(item?.id ?? '').trim();
        return String(item).trim();
      })
      .filter(Boolean);
  }
  if (filterValue?.id) return [String(filterValue.id)];
  return [];
};

export const formatPostingDate = (dateStr) => {
  if (!dateStr) return null;
  const raw = String(dateStr);
  const portion = raw.includes('T') ? raw.split('T')[0] : raw;
  const parts = portion.split('-');
  if (parts.length !== 3) return portion;
  return `${parts[1]}/${parts[2]}/${parts[0]}`;
};

export const sanitizeSearchText = (value = '') => value?.toString().trim() || '';

export const createStaticDataFetcher = (data) => () => Promise.resolve({ data, isSuccess: true });

export const { EMPTY_ARRAY } = DEFAULTS;
